import { render, staticRenderFns } from "./ModuleDescriptionSlidebar.vue?vue&type=template&id=99515614"
import script from "./ModuleDescriptionSlidebar.vue?vue&type=script&lang=js"
export * from "./ModuleDescriptionSlidebar.vue?vue&type=script&lang=js"
import style0 from "./ModuleDescriptionSlidebar.vue?vue&type=style&index=0&id=99515614&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports